<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row row-space">

        <div class="form-item">
            <div v-if="globalStore.ckperfilinspetor">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ globalStore.nmsim }}</div>
            </div>
            <div v-if="!globalStore.ckperfilinspetor">
                <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
            </div>
        </div>
        
        <button type="button" class="buttom-icon--map" @click="lerDados" />
        <button type="button" class="buttom-icon--close" @click="closeForm" />
    </div>

    <div v-if="lsDados" class="form-edit-page">
        <div>
            <MapArrayLegendComponent class="map" :coordinates="lsDados"></MapArrayLegendComponent>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import MapArrayLegendComponent from '@/components/MapArrayLegendComponent.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const isLoading = ref(false);
const lsDados = ref(null);
const msgAlerta = ref(null);
const idSim = ref(0);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await genericPost('/dados/coordenadas', {
            idep: globalStore.idep,
            idsim: globalStore.ckperfilinspetor ? globalStore.idsim : idSim.value});
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}
</script>